export interface VarcharArrayDatatypeInterface extends String {
	data?: string[];
}

export class VarcharArrayDatatypeClass
	extends String
	implements VarcharArrayDatatypeInterface
{
	data?: string[];
}
